<template>
  <span></span>
</template>

<script>
export default {
  name: "query-string-to-state",
  props: {
    variables: Object
  },
  mounted () {
    console.log("entries: ", Object.entries(this.variables))
    Object.entries(this.variables).forEach((entry) => {
      this.$store.state[entry[1]] = this.$route.query[entry[0]]
    })
  }
};
</script>
